import type { UserPreferencesPort } from '../domain/user-preferences'

const getUserPreferences = (port: UserPreferencesPort) => port.get()

export { getUserPreferences }
